//C:\Users\ak192\Downloads\calvant-frontend-2-cv_nextjs4\calvant-frontend-2-cv_nextjs4\app\datasheet

"use client";

import DatasheetPage from "@/static-pages/datasheet";

export default function Page() {
  return <DatasheetPage />;
}
